import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=7022fb78&lang=less&scoped=true"
import "./Login.vue?vue&type=style&index=1&id=7022fb78&lang=less"

import exportComponent from "/data/web/pay/thpay/thpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7022fb78"]])

export default __exports__